import React, { useState, useEffect, useContext, useMemo } from "react";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { Spacing, Colors, UIRelatedConstants } from "../../theme/Theme";
import { useLocation, useHistory } from "react-router";
import { RBCardView } from "../../components/RBCardView";
import { RBDatePickerSearch } from "../../components/RBDateTimePicker";
import moment from "moment-timezone";
import { ColumnStyle } from "../../theme/ComponentTheme";
import { RBButton } from "../../components/RBButton";
import { ShiftService } from "../../api/ShiftService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { formatWorkerType } from "../../util/FormattingService";
import {
  defaultKmAllowanceIcon,
  defaultAccomodationAllowanceIcon,
} from "../../util/Icons";
import { Button, Checkbox, FormControlLabel, Link, Typography, makeStyles, Select, MenuItem } from "@material-ui/core";
import { ApprovalModeEnum, RoutePathConstant } from "../../util/Common";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { AuthService } from "../../api/AuthService";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum } from "../../api/constants";
import { workerTypeEnum } from "../../util/Enumeration";
import { defaultAllowOffersIcon } from "../../components/RBShiftRelatedIcons";
import { detailTextStyle, titleHeaderTextStyle } from "../../components/TextWithHeader";
import { RBTextField } from "../../components/RBTextField";
import { RBSwitch } from "../../components/RBSwitch";
import { showOnHoldAlert } from "../../util/showOnHoldAlert";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { resolveShiftPaymentIndicator } from "../../util/rbPay";
import { ADVANCED_FILTERS_STORAGE_KEY } from "../../util/advancedSearchFilters";
import { RBPayrollVerifiedBadge } from "./RBPayrollVerifiedBadge";
import { ShiftPaymentField } from "../../components/ShiftPayment/ShiftPaymentField";
import { AccountInfoContext } from "../../components/AccountInfoContext";
export const SearchShiftPage = () => {
  const location = useLocation<{ background: string }>();
  const history = useHistory();
  const [showModal, setShowModal] = useState(true);
  const [searchStartDate, setSearchStartDate] = useState<any>(
    moment().toISOString()
  );
  const [searchEndDate, setSearchEndDate] = useState<any>(
          moment()
          .add(1, 'months')
          .toISOString(),
  );
  const [showDialog, setShowDialog] = useState(false);
  
  // Storage key for advanced filters
  const ADVANCED_FILTERS = ADVANCED_FILTERS_STORAGE_KEY;

  // Lazy initializer to load filters from localStorage only once during component initialization
  const getInitialFilterValue = (key: string, defaultValue: any) => {
    try {
      const stored = localStorage.getItem(ADVANCED_FILTERS);
      if (stored) {
        const data = JSON.parse(stored);
        return data[key] !== undefined ? data[key] : defaultValue;
      }
    } catch (err) {
      console.error('Error loading filter from localStorage:', err);
    }
    return defaultValue;
  };

  const [sortByDistance, setSortByDistance] = useState<any>(() => getInitialFilterValue('sortByDistance', false));
  const [extendedSearch, setExtendedSearch] = useState(() => getInitialFilterValue('extendedSearch', false));
  const [shiftNumber, setShiftNumber] = useState(() => getInitialFilterValue('shiftNumber', ''));
  const [ignoreMinimumWage, setIgnoreMinimumWage] = useState(() => getInitialFilterValue('ignoreMinimumWage', false));
  const [ignoreWorkerUnavailability, setIgnoreWorkerUnavailability] = useState(() => getInitialFilterValue('ignoreWorkerUnavailability', false));
  const [sortByWage, setSortByWage] = useState(() => getInitialFilterValue('sortByWage', 'none'));
  const [travelAllowance, setTravelAllowance] = useState(() => getInitialFilterValue('travelAllowance', false));
  const [offers, setOffers] = useState(() => getInitialFilterValue('offers', false));
  const [hasAssistantOnSite, setHasAssistantOnSite] = useState(() => getInitialFilterValue('hasAssistantOnSite', false));
  const [hasTechnicianOnSite, setHasTechnicianOnSite] = useState(() => getInitialFilterValue('hasTechnicianOnSite', false));

  const { industryMode,primaryColor,secondaryColor ,contactEmail} = useContext(RBContext);
  // months
  const [shiftSearchRange, setShiftSearchRange] = useState(1);
  const [searchedShifts, setSearchedShifts] = useState<ObjectLiteral[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const { accountInformation } = useContext(AccountInfoContext);
  const [account, setAccount] = useState<any>([]);
  const [endTimeValidation,setEndTimeValidation] = useState<any>(null);
  const [searchPressed, setSearchPressed] = useState(() => getInitialFilterValue('searchPressed', false));

  const sortedShifts = useMemo(() => {
    let data = [...searchedShifts];
    if (sortByDistance) {
      data = data.sort((a: any, b: any) => a.distance - b.distance);
    }
    if (sortByWage === 'highest') {
      data = data.sort((a: any, b: any) => {
        const wageA = a.actualCommission !== undefined && a.actualCommission !== null ? a.wage / 100 : ShiftService.getWage(a, account) / 100;
        const wageB = b.actualCommission !== undefined && b.actualCommission !== null ? b.wage / 100 : ShiftService.getWage(b, account) / 100;
        return wageB - wageA;
      });
    } else if (sortByWage === 'lowest') {
      data = data.sort((a: any, b: any) => {
        const wageA = a.actualCommission !== undefined && a.actualCommission !== null ? a.wage / 100 : ShiftService.getWage(a, account) / 100;
        const wageB = b.actualCommission !== undefined && b.actualCommission !== null ? b.wage / 100 : ShiftService.getWage(b, account) / 100;
        return wageA - wageB;
      });
    }
    const pharmacyIdCounts: any = {};
    data.forEach((item: any) => {
      const pharmacyId = item.pharmacy.id;
      if (pharmacyIdCounts[pharmacyId]) {
        pharmacyIdCounts[pharmacyId] += 1;
      } else {
        pharmacyIdCounts[pharmacyId] = 1;
      }
    });
    const updatedData = data.map((item: any) => {
      const pharmacyId = item.pharmacy.id;
      const viewMultipleShift = pharmacyIdCounts[pharmacyId] > 1;
      return {
        ...item,
        viewMultipleShift: viewMultipleShift
      };
    });
    return updatedData;
  }, [searchedShifts, sortByWage, sortByDistance, account]);
  
  const [isAlertShowing, setIsAlertShowing] = useState(false);
  const [alertInfo,setAlertInfo]  = useState <any> ({title:"",message:"", buttons:[]})

  useEffect(() => {
    loadRBShiftPreference();
  }, []);

  // Save advanced filters to localStorage whenever they change
  useEffect(() => {
    const filtersData = {
      sortByDistance,
      extendedSearch,
      shiftNumber,
      ignoreMinimumWage,
      ignoreWorkerUnavailability,
      sortByWage,
      travelAllowance,
      offers,
      hasAssistantOnSite,
      hasTechnicianOnSite,
      searchPressed,
    };
    localStorage.setItem(ADVANCED_FILTERS, JSON.stringify(filtersData));
  }, [sortByDistance, extendedSearch, shiftNumber, ignoreMinimumWage, ignoreWorkerUnavailability, sortByWage, travelAllowance, offers, hasAssistantOnSite, hasTechnicianOnSite, searchPressed]);

  useEffect(() => {
    fetchShifts();
  }, [shiftSearchRange]);

  useEffect(() => {
    fetchShifts();
  }, [accountInformation]);

  const useStyles = makeStyles({
    root: {
      minWidth: 475,
      marginLeft: -250,
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    CardContent: {
      paddingTop: 8,
      "&:last-child": {
        paddingBottom: 8,
      },
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    button: {
      borderRadius: UIRelatedConstants.ButtonBorderRadius,
      borderWidth: 1,
      backgroundColor: "#FFF",
      "&:hover": {
        backgroundColor: "#CDCDCD",
      },
    },
  });
  const classes = useStyles();

  const loadRBShiftPreference = async () => {
    try {
      setIsLoading(true);
      const userData = accountInformation;
      setAccount(userData);
      const rbShiftPreference = await AuthService.getRBShiftPreference();
      if (typeof rbShiftPreference.shiftSearchRange !== "undefined") {
        setSearchEndDate(
          moment().add(rbShiftPreference.shiftSearchRange, "months").toISOString(),
        );
        setShiftSearchRange(rbShiftPreference.shiftSearchRange);
      }
    } catch (err) {
      const errorMessage = err.response ? err.response.data.message : err.message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const convertOffsetToString = (offset: any) => {
    let value = '';
    const absOffset = Math.abs(offset);
    const hr = absOffset / 60;
    const min = absOffset % 60;
    if (offset < 0) {
      value = value + '-';
    }
    else {
      value = value + '-';
    }
    if (hr < 10) {
      value = value + '0' + hr;
    }
    else {
      value = value + hr;
    }
    if (min < 10) {
      value = value + ':0' + min;
    }
    else {
      value = value + ':' + min;
    }
    return value;
  }

  const onAdvanceSearchPressed = () => {
    setShowDialog(true);
    // Check if all filters are at default values, if so mark search as not pressed
    if (sortByDistance === false && extendedSearch === false && shiftNumber === '' && ignoreMinimumWage === false && ignoreWorkerUnavailability === false && sortByWage === 'none' && travelAllowance === false && offers === false && hasAssistantOnSite === false && hasTechnicianOnSite === false) {
      setSearchPressed(false);
    }
    // Only reset filters if no search has been performed yet
    // This ensures clean defaults on first open, but preserves filters after search
    if (!searchPressed) {
      setSortByDistance(false);
      setExtendedSearch(false);
      setShiftNumber('');
      setIgnoreMinimumWage(false);
      setIgnoreWorkerUnavailability(false);
      setSortByWage('none');
      setTravelAllowance(false);
      setOffers(false);
      setHasAssistantOnSite(false);
      setHasTechnicianOnSite(false);
    }
  };
  const closeDialog = () => {
    // localStorage.removeItem(ADVANCED_FILTERS);
    // setSortByDistance(false);
    // setExtendedSearch(false);
    // setShiftNumber('');
    // setIgnoreMinimumWage(false);
    // setSortByWage('none');
    // setTravelAllowance(false);
    // setOffers(false);
    // setHasAssistantOnSite(false);
    // setHasTechnicianOnSite(false);
    // setSearchPressed(false); 
    // fetchShifts();
    setShowDialog(false);
  };
  const setAlertState = (newState:any) => {
    setIsAlertShowing(newState.isAlertShowing);
    setAlertInfo(newState.alertInfo);
  };
  const fetchShifts = async () => {
    try {

      const userData = accountInformation;
      if (!userData || !userData.networks || userData.networks.length === 0) return;

      setAccount(userData);
      setIsLoading(true);
    
      let wageSortOrder: string | undefined = undefined;
      if (sortByWage === 'highest') {
        wageSortOrder = 'DESC';
      } else if (sortByWage === 'lowest') {
        wageSortOrder = 'ASC';
      }
      
       if (userData?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold) {
        setShowDialog(false);   // hide modal if it's open
        setShowModal(false);    // <-- make sure your modal visibility flag is false
        setIsLoading(false);

        showOnHoldAlert({
          setAlertState: setAlertState,
          primaryColor,
          contactEmail,
          page:'dashboard',
          navigation:history
        });
        return;
      }

      const responceData = await ShiftService.searchShiftsByDateRange(
        searchStartDate,
        moment(searchEndDate)
        .add(1, 'day')
        .toISOString(),
        userData.networks[0].id,
        extendedSearch,
        shiftNumber,
        ignoreMinimumWage,
        wageSortOrder,
        travelAllowance,
        offers,
        hasAssistantOnSite,
        hasTechnicianOnSite,
        ignoreWorkerUnavailability
      );
      setShowDialog(false)
      setSearchPressed(true)
      console.log("SearchShiftPage ", responceData);
      setSearchedShifts(responceData.data);
    } catch (err) {
      const errorMessage = err.response ? err.response.data.message : err.message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const renderSearchShiftBar = () => {
    return (
      <RBCardView
        marginHorizontal={Spacing.large}
        style={{
          padding: Spacing.large,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ ...ColumnStyle, paddingBottom: Spacing.smaller, marginBottom: Spacing.small }}>
          <RBDatePickerSearch
            style={{ display: "flex", flex: 2 }}
            label="Start Date"
            value={searchStartDate}
            onChange={(date) => {
              const newDate = date ? date : searchStartDate;
              const offsetString = convertOffsetToString(moment().tz(account.pharmacist.address.timezone).utcOffset());
              let currentDate = moment(date)
              let year = currentDate.format('YYYY')
              let month = currentDate.format('MM')
              let day = currentDate.format('DD')
              let convertedDate = moment(moment(year + '-' + month + '-' + day).format('YYYY-MM-DDTHH:mm:ss') + offsetString);
              let newStartDate = moment(moment(convertedDate).tz(account.pharmacist.address.timezone)).utc().toISOString();

              setSearchStartDate(newStartDate);
              const firstDate = new Date(newDate);
              const secondDate = new Date(searchEndDate);

              // Set time part of both dates to midnight (00:00:00)
              firstDate.setHours(0, 0, 0, 0);
              secondDate.setHours(0, 0, 0, 0);
              if (firstDate > secondDate) {
                setEndTimeValidation("Enter valid end time")
              }
              else {
                setEndTimeValidation(null)
              }
            }}
          />
          <RBEmptyBlock />
          <RBDatePickerSearch
            style={{ display: "flex", flex: 2 }}
            label="End Date"
            value={searchEndDate}
            onChange={(date) => {
              const newDate = date ? date : searchEndDate;

              const offsetString = convertOffsetToString(moment().tz(account.pharmacist.address.timezone).utcOffset());
              let currentDate = moment(date)
              let year = currentDate.format('YYYY')
              let month = currentDate.format('MM')
              let day = currentDate.format('DD')
              let convertedDate = moment(moment(year + '-' + month + '-' + day).format('YYYY-MM-DDTHH:mm:ss') + offsetString);
              let newEndDate = moment(moment(convertedDate).tz(account.pharmacist.address.timezone)).utc().toISOString();

              setSearchEndDate(newEndDate);
              const firstDate = new Date(searchStartDate);
              const secondDate = new Date(newDate);

              // Set time part of both dates to midnight (00:00:00)
              firstDate.setHours(0, 0, 0, 0);
              secondDate.setHours(0, 0, 0, 0);
              if (firstDate > secondDate) {
                setEndTimeValidation("Enter valid end time")
              }
              else {
                setEndTimeValidation(null)
              }

            }}
          />
        </div>
        <div
          style={{
            ...ColumnStyle, marginTop: -5, alignItems: "center"
          }}
        >
          <div style={{ display: "flex", flex: 2 }}>
          </div>
          <div style={{ display: "flex", flex: 2 }}>
            {endTimeValidation != null && (
              <Typography variant="caption" color="error" style={{ marginLeft: 20 }}>
                {endTimeValidation}
              </Typography>
            )}
          </div>

        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: Spacing.small }}>
          <RBButton
            text="Search"
            disabled={endTimeValidation !== null}
            isLoading={isLoading}
            onClick={() => fetchShifts()}
            style={{ display: "flex", flex: 1 }}
            buttonBackgroundColor={secondaryColor}
          />
          <RBButton
            text="Advanced Filters"
            onClick={() => onAdvanceSearchPressed()}
            style={{ display: "flex", flex: 1 }}
            buttonBackgroundColor={primaryColor}
          />
        </div>
      </RBCardView>
    );
  };
  const viewMultipleShifts = (shift:any) =>{
    history.push(`${RoutePathConstant.SearchMultipleShiftsByLocation}`, {
      background: location.state?.background,
      startDate: moment(searchStartDate)
        .startOf('day')
        .toISOString(),
      endDate: moment(searchEndDate)
        .endOf('day')
        .toISOString(),
      account: account,
      pharmacy: shift.pharmacy,
      extendedSearch: extendedSearch,
      shiftNumber: shiftNumber,
      ignoreMinimumWage: ignoreMinimumWage,
      ignoreWorkerUnavailability: ignoreWorkerUnavailability,
      wageSortOrder: sortByWage,
      travelAllowance: travelAllowance,
      offers: offers,
      hasAssistantOnSite: hasAssistantOnSite,
      hasTechnicianOnSite: hasTechnicianOnSite,
    });
  }
  
  const renderSearchShiftResultDetail = (shift: ObjectLiteral) => {
    const startTime = moment(shift.startTime).tz(shift.shiftTimeZone);
    const endTime = moment(shift.endTime).tz(shift.shiftTimeZone);
    const hoursDisplay = ShiftService.getShiftLengthDisplayForOriginal(shift);
    //const dateString = startTime.format('dddd MMMM Do YYYY');
    const dateString = startTime.format("ddd, MMM Do YYYY");
    const wage:any = shift.actualCommission !== undefined && shift.actualCommission !== null ? shift.wage / 100 : ShiftService.getWage(shift,account) / 100;
    const shiftDistance = shift.distance;
    const city = shift.shiftCity;
    const kmAllowanceAvailable = shift.kmAllowance > 0;
    const accomodationAllowanceAvailable = shift.accomodationAllowance > 0;
    const workerType = formatWorkerType(shift.pharmacistType);
    const workerNetworkId = account.networks[0].id;
    // US6559 Phase 2 - resolved once and shared by the Shift Payment field and the legacy
    // network-paid badge branch below, so the card never evaluates the rule twice.
    const paymentIndicator = resolveShiftPaymentIndicator(shift);


    return (
      <RBCardView
        key={shift.id}
        marginHorizontal={Spacing.large}
        paddingHorizontal={Spacing.large}
        paddingVertical={Spacing.small}
        onClick={() => {
          console.log("RBCardView onClick");
          history.push(`${RoutePathConstant.SearchShiftDetail}${shift.id}`, {
            //background: location,
            background: location.state?.background,
            // US6559: carry the authoritative RB Pay status from the search response so
            // the apply page can gate reliably (the detail endpoint's copies are stale).
            // rbPayStatus is the new source of truth; rbPayApproved kept for BE rollout.
            rbPayStatus: shift.pharmacy?.rbPayStatus ?? null,
            rbPayApproved: shift.pharmacy?.rbPayApproved === true,
            // Phase 2: paymentType is now the primary driver of isLocationOnRBPay, so the
            // pre-detail-fetch fallback needs it too or the gate would read a half-populated
            // pharmacy and always resolve to "not on RB Pay".
            paymentType: shift.pharmacy?.paymentType ?? null,
            networkPaid: shift.pharmacy?.networkPaid ?? null,
          });
        }}
        clickable={true}
        style={{
          //  padding: Spacing.large,
          marginTop: Spacing.medium,
        }}
      >
        <div style={{ ...ColumnStyle,flex:3,paddingBottom: Spacing.smaller, }}>
          <Typography style={{ fontWeight: "bold" }}>{dateString}</Typography>
          <Typography style={{ fontWeight: "bold" }}></Typography>
          <Typography style={{ fontWeight: "bold" }}>
              <div style={{ flex: 1, alignItems: "flex-start" }}>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >

                  <div
                    style={{
                      marginLeft: Spacing.smallest,
                      fontWeight: "bold",
                      color: wage === 0 && secondaryColor,
                    }}
                  >
                   {wage === 0 ? "Open Offer" : `$${wage.toFixed(2)}/hr` }
                  </div>
                <div style={{ marginLeft: Spacing.smaller }}>
                  {shift.allowOffers && defaultAllowOffersIcon(secondaryColor)}
                </div>
                </div>

              </div>
          </Typography>
        </div>
        <div style={{ ...ColumnStyle, paddingBottom: Spacing.smaller,flex:3 }}>
          <Typography style={{ fontWeight: "bold", width:'45%' }}>
            {startTime.format("h:mm a")} - {endTime.format("h:mm a")} 
          </Typography>
          <Typography>{workerType}</Typography>
        </div>
        <div style={{ ...ColumnStyle, paddingBottom: Spacing.smaller,flex:3 }}>
           <Typography style={{ fontWeight: "bold", width:'45%' }}>
            ({hoursDisplay})
          </Typography>
          <div>
            {kmAllowanceAvailable && defaultKmAllowanceIcon(primaryColor)}
            {accomodationAllowanceAvailable &&
              defaultAccomodationAllowanceIcon(primaryColor)}
          </div>
        </div>
        <div style={{ ...ColumnStyle, paddingBottom: Spacing.smaller,flex:3}}>
        <Typography>
            {(shiftDistance / 1000).toFixed(0)} km away{" "}
            {city ? `in ${city} (Est.) ` : ""}
          </Typography>
        </div>
        {/*
          US6559 Phase 2 - bottom row. The in/out-of-network trust icon moved UP out of its
          own stacked column to sit beside "View Multiple Shifts" (client: "moved here to
          keep space optimized"), which frees the left side for the Shift Payment field.
          Network-paid shifts keep the previous standalone "RB Pay Verified" chip instead of
          the new field - for those, behaviour is unchanged.
        */}
        {/* flexWrap + minWidth:0 on the left / flexShrink:0 on the right: at narrow widths the
            field, the 50px network icon and the button cannot share one line, and both the
            label and the badge are nowrap. Wrapping the field onto its own line is the graceful
            failure; overlapping the icon is not. */}
        <div
          style={{
            ...ColumnStyle,
            paddingBottom: 0,
            alignItems: "center",
            flexWrap: "wrap",
            gap: Spacing.smaller,
          }}
        >
          <div style={{marginTop:-5, minWidth: 0, flexShrink: 1}}>
            {paymentIndicator.showLegacyBadge && (
              <RBPayrollVerifiedBadge style={{ marginBottom: Spacing.smaller }} />
            )}
            <ShiftPaymentField shift={shift} indicator={paymentIndicator} inline />
          </div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", flexShrink: 0 }}>
            {
              (account.pharmacist.approval?.rbVerified === true &&
                account.networks[0].isTrustNetwork === true &&
                <Typography>
                  <img
                  src={shift.pharmacy?.networkId === workerNetworkId ? require('../../img/50x50-01.png') : require('../../img/100x100-02-01.png')}
                  alt="Network Logo"
                  style={{

                    height: 50,
                    marginRight: 10,
                    marginBottom: -20
                  }}
                />
                </Typography>)
            }
            {shift.viewMultipleShift === true && <div>
            <Button
            className={classes.button}
            variant="outlined"
            style={{
              borderColor: primaryColor,
              color: primaryColor,
              textTransform: "none",
            }}
            onClick={(event: any) => {
              event.stopPropagation();
              viewMultipleShifts(shift)
            }}
          >
            View Multiple Shifts
          </Button>
          </div>}
          </div>
        </div>
      </RBCardView>
    );
  };
  const renderSearchShiftResults = () => {
    return (
      <>
        {sortedShifts.length === 0 && (
          <RBCardView
            marginHorizontal={Spacing.medium}
            style={{
              padding: Spacing.large,
              marginTop: Spacing.medium,
            }}
          >
            No shifts available during this period
          </RBCardView>
        )}
        {sortedShifts.length >= 1 &&
          sortedShifts.map((shift: ObjectLiteral) =>
            renderSearchShiftResultDetail(shift)
          )}
      </>
    );
  };
  const renderSearchShiftContent = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: Spacing.medium,
        }}
      >
        {renderSearchShiftBar()}
        {renderSearchShiftResults()}
      </div>
    );
  };

  const renderAdvancedFilterContent = () =>{
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: Spacing.medium,
        }}
      >
        <RBCardView
        marginHorizontal={Spacing.large}
        style={{
          padding: Spacing.large,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ paddingBottom: Spacing.smaller, marginBottom: Spacing.small }}>

              
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Sort by Distance
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                }}
                control={
                  <Checkbox
                    checked={sortByDistance}
                    onChange={() =>
                      setSortByDistance((prev:any) => !prev)
                    }
                    style={{
                      color: sortByDistance
                        ? secondaryColor
                        : Colors.darkGrey,
                    }}
                  />
                }
                label=""
              />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Extend Search
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={extendedSearch}
                    onChange={(e) => setExtendedSearch(e.target.checked)}
                    name={"extendedSearch"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />

            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
              Search by Shift Number
              </Typography>
              <RBEmptyBlock />
              <RBTextField
                    className="custom-focused-input"
                    style={{
                      display: "flex",
                      flex: 1,
                      maxHeight: "40px",
                      borderColor: "black"
                    }}

                    placeholder={"Search by Shift Number"}
                    value={shiftNumber}
                    onChange={(e) => setShiftNumber(e.target.value)}
                  />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Ignore Minimum Wage
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={ignoreMinimumWage}
                    onChange={(e) => setIgnoreMinimumWage(e.target.checked)}
                    name={"ignoreMinimumWage"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Ignore My Unavailable Days
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={ignoreWorkerUnavailability}
                    onChange={(e) => setIgnoreWorkerUnavailability(e.target.checked)}
                    name={"ignoreWorkerUnavailability"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Sort by Wage
              </Typography>
              <RBEmptyBlock />
              <Select
                value={sortByWage}
                onChange={(e) => setSortByWage(e.target.value as string)}
                style={{
                  display: "flex",
                  flex: 1,
                  maxHeight: "40px",
                }}
              >
                <MenuItem value="none">None</MenuItem>
                <MenuItem value="highest">High to Low</MenuItem>
                <MenuItem value="lowest">Low to High</MenuItem>
              </Select>
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  alignItems: "center",
                  gap: Spacing.small,
                }}
              >
                <Typography style={{ display: "flex" }}>
                  Travel Allowance
                </Typography>
                {defaultKmAllowanceIcon(primaryColor)}
                {defaultAccomodationAllowanceIcon(primaryColor)}
              </div>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={travelAllowance}
                    onChange={(e) => setTravelAllowance(e.target.checked)}
                    name={"travelAllowance"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  alignItems: "center",
                  gap: Spacing.small,
                }}
              >
                <Typography style={{ display: "flex" }}>
                  Offers
                </Typography>
                {defaultAllowOffersIcon(secondaryColor)}
              </div>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={offers}
                    onChange={(e) => setOffers(e.target.checked)}
                    name={"offers"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            {account?.pharmacist?.type === workerTypeEnum.pharmacist && (
            <>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Assistant On Site
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={hasAssistantOnSite}
                    onChange={(e) => setHasAssistantOnSite(e.target.checked)}
                    name={"hasAssistantOnSite"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            <div
              style={{
                ...ColumnStyle,
                alignItems: "center",
              }}
            >
              <Typography style={{ display: "flex", flex: 1 }}>
                Technician On Site
              </Typography>
              <RBEmptyBlock />
              <FormControlLabel
                style={{
                  display: "flex",
                  flex: 1,
                  marginLeft:"2%"
                }}
                control={
                  <RBSwitch
                    checked={hasTechnicianOnSite}
                    onChange={(e) => setHasTechnicianOnSite(e.target.checked)}
                    name={"hasTechnicianOnSite"}
                    label={""}
                    formControlStyle={{ marginBottom: Spacing.large }}
                  />
                }
                label=""
              />
            </div>
            </>
            )}
            <div
              style={{
                display: "flex",
                flex: 1,
                paddingTop:15
              }}
            >
            <Typography style={{ display: "flex"}}>
            Note: Search is limited by the selected Start Date '{moment(searchStartDate).format('MM/DD/YYYY') }' and End Date '{moment(searchEndDate).format('MM/DD/YYYY') }'. Expand the range to see more results.
              </Typography>
              </div>

            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "flex-end",
              }}
            >
               <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={primaryColor}
              onClick={() => {
                setSortByDistance(false)
                setExtendedSearch(false)
                setShiftNumber('')
                setIgnoreMinimumWage(false)
                setIgnoreWorkerUnavailability(false)
                setSortByWage('none')
                setTravelAllowance(false)
                setOffers(false)
                setHasAssistantOnSite(false)
                setHasTechnicianOnSite(false)
                setSearchPressed(false)
                // Clear localStorage
                // localStorage.removeItem(ADVANCED_FILTERS);
                // fetchShifts();
              }}
              text="Clear"
            />
            <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={primaryColor}
              onClick={() => fetchShifts()}
              disabled={endTimeValidation !== null}
            isLoading={isLoading}
              text="Search"
            />

            </div>
        </div>
      </RBCardView>
      </div>
    );
  }

  const onClose = () => {
    localStorage.removeItem(ADVANCED_FILTERS);
    goBackToPreviousLocation();
  };

  const goBackToPreviousLocation = () => {
    if (location.state && location.state.background) {
      setShowModal(false);
      history.goBack();
    } else {
      setShowModal(false);
      history.push("/dashboard");
    }
  };
   if(isLoading)  {
        return <LoadingIndicator />
      }
  
  return (
    <>
      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />
      <RBAlert
        show={isAlertShowing}
        alertTitle={alertInfo?.title}
        alertMessage={alertInfo?.message}
        buttons={alertInfo?.buttons}
      />
      <RBModal
        backArrowIcon
        open={showModal}
        onClose={onClose}
        modalTitle={"Search Shifts"}
        header={
          <RBEmptyBlock
            style={{
              width: "100%",
              height: Spacing.large,
              backgroundColor: Colors.defaultGrey,
              flexShrink: 0,
            }}
          />
        }
        children={renderSearchShiftContent()}
      />

      <RBModal
        backArrowIcon
        open={showDialog}
        onClose={closeDialog}
        modalTitle={"Advanced Filters"}
        header={
          <RBEmptyBlock
            style={{
              width: "100%",
              height: Spacing.large,
              backgroundColor: Colors.defaultGrey,
              flexShrink: 0,
            }}
          />
        }
        children={renderAdvancedFilterContent()}
      />
    </>
  );
};